// @ts-nocheck
/* eslint-disable no-restricted-globals */
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import RecoveryStep1 from "../recoverySteps/RecoveryStep1";
import RecoveryStep2 from "../recoverySteps/RecoveryStep2";
import RecoveryStep3 from "../recoverySteps/RecoveryStep3";
import RecoveryComplete from "../recoverySteps/RecoveryComplete";
import { RecoveryContext } from "../recoveryContext";
import { loginSchema } from "./Schema";
import { useStores } from "hooks/useStores";
import { ROUTES_PATHS } from 'const';
import { observer } from "mobx-react";

export const LkLogin = observer(() => {
  const { modalStore, api, cartStore } = useStores()
  const [isLogin, setIsLogin] = useState(true);
  const [step1, setStep1] = useState(true);
  const [step2, setStep2] = useState(false);
  const [step3, setStep3] = useState(false);
  const [recoveryComplete, setRecoveryComplete] = useState(false);
  const [incorrectLogin, setIncorrectLogin] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [contextPassword, setContextPassword] = useState("");
  const [contextEmail, setContextEmail] = useState("");

  const {getCartItems} = cartStore

  const navigate = useNavigate()

  const lkLoginModalClose = () => {
    modalStore.close();

    reset({
      email: "",
      password: "",
    });
    setStep1(true);
    setIsLogin(true);
    setStep2(false);
    setStep3(false);
    setRecoveryComplete(false);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(loginSchema),
  });


  const onSubmit = (data) => {
    api.auth.postLogin({
      username: data.email,
      password: data.password,
    })
      .then(() => {
        navigate(ROUTES_PATHS.PERSONAL)
        lkLoginModalClose();
        setIsLogin(true);
        getCartItems();
      })
      .catch((err) => {
        console.log("incorrect login or password, pls try again", err);
        setIncorrectLogin(true);
        if (err.response.status === 500) {
        }
      });
  };

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const stepHandler = (props) => {
    if (props === 2) {
      setStep1(false);
      setStep2(true);
      return;
    }
    if (props === 3) {
      setStep2(false);
      setStep3(true);
      return;
    }
    if (props === 4) {
      setStep3(false);
      setRecoveryComplete(true);
      return;
    }
    if (props === 1) {
      setRecoveryComplete(false);
      setIsLogin(true);
      return;
    }
  };

  const value = {
    contextPassword,
    setContextPassword,
    contextEmail,
    setContextEmail,
  };

  return (
    <>
      {isLogin ? (
        <div className='lkLogin-main-content'>
          <h1 className='lkLogin-main__title'>Вход</h1>
          {incorrectLogin && (
            <div className='lkLogin-incorrectLogin'>
              неверный логин или пароль
            </div>
          )}
          <form className='lkLogin-form' onSubmit={handleSubmit(onSubmit)}>
            <div className='lkLogin-form-item'>
              <label htmlFor='email'>
                Email<span className='lkLogin-form__span'>*</span>
              </label>
              <input
                autoFocus
                {...register("email")}
                id='email'
                name='email'
                type='email'
                className='lkLogin-input'
              />
              <p className='lkLogin-form__err'>{errors.email?.message}</p>
            </div>
            <div className='lkLogin-form-item'>
              <label htmlFor='password'>
                Пароль<span className='lkLogin-form__span'>*</span>
              </label>
              <input
                {...register("password")}
                id='password'
                name='password'
                type={passwordShown ? "text" : "password"}
                className='lkLogin-input'
              />
              <div
                className='lkLogin-showHide-pass'
                onClick={togglePasswordVisiblity}
              >
                {passwordShown ? <>скрыть</> : <>показать</>}
              </div>
              <p className='lkLogin-form__err'>
                {errors.password?.message}
              </p>
            </div>
            <div>
              <button
                className='lkLogin-form-forgotPass'
                onClick={() => setIsLogin(false)}
              >
                Забыли пароль?
              </button>
            </div>
            <div>
              <button className='lkLogin-form-btn' type='submit'>
                Вход
              </button>
            </div>
          </form>
          <Link
            className='lkLogin-form-btn-reg'
            to={ROUTES_PATHS.REGISTRATION}
            onClick={lkLoginModalClose}
          >
            Регистрация
          </Link>
        </div>
      ) : (
        <RecoveryContext.Provider value={value}>
          <div className='lkLogin-main-content'>
            <button onClick={() => setIsLogin(true)} className='lkLogin-back'>
              <div className='lkLogin-back-image' />
              <div className='lkLogin-back-title'>Назад</div>
            </button>
            <div className='lkLogin-recovery-content'>
              {step1 && <RecoveryStep1 nextStep={stepHandler} />}
              {step2 && <RecoveryStep2 nextStep={stepHandler} />}
              {step3 && <RecoveryStep3 nextStep={stepHandler} />}
              {recoveryComplete && (
                <RecoveryComplete nextStep={stepHandler} />
              )}
            </div>
          </div>
        </RecoveryContext.Provider>
      )}
    </>

  );
})
